var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPHWithArrows(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 40,
    viewBox: "0 0 33 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.15503 14.8419H7.61152V16.7801H7.7242C7.97961 16.0739 8.39279 15.5331 8.96371 15.1575C9.54966 14.7668 10.2333 14.5715 11.0145 14.5715C12.502 14.5715 13.6513 15.1124 14.4626 16.1941C15.274 17.2609 15.6796 18.7633 15.6796 20.7015C15.6796 22.6396 15.274 24.1496 14.4626 25.2313C13.6513 26.298 12.502 26.8314 11.0145 26.8314C10.2333 26.8314 9.54966 26.6361 8.96371 26.2455C8.39279 25.8548 7.97961 25.3139 7.7242 24.6228H7.61152V31.0683H5.15503V14.8419ZM10.2708 24.713C11.1272 24.713 11.8108 24.4425 12.3217 23.9017C12.8325 23.3458 13.0879 22.6171 13.0879 21.7156V19.6873C13.0879 18.7859 12.8325 18.0647 12.3217 17.5238C11.8108 16.9679 11.1272 16.6899 10.2708 16.6899C9.51962 16.6899 8.88859 16.8778 8.37776 17.2534C7.86693 17.6139 7.61152 18.0947 7.61152 18.6957V22.7072C7.61152 23.3082 7.86693 23.7965 8.37776 24.1721C8.88859 24.5327 9.51962 24.713 10.2708 24.713Z",
    fill: "#666666"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3406 19.7099H21.219V26.561H18.6724V10.8304H21.219V17.4562H28.3406V10.8304H30.8872V26.561H28.3406V19.7099Z",
    fill: "#666666"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.973482 1.98957C0.435672 1.98957 0 1.54407 0 0.994784C0 0.445206 0.435961 0 0.973482 0H32.0265C32.5643 0 33 0.4455 33 0.994784C33 1.54436 32.564 1.98957 32.0265 1.98957H0.973482Z",
    fill: "#666666"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0.973482 39.439C0.435672 39.439 0 38.9935 0 38.4442C0 37.8947 0.435961 37.4495 0.973482 37.4495H32.0265C32.5643 37.4495 33 37.895 33 38.4442C33 38.9938 32.564 39.439 32.0265 39.439H0.973482Z",
    fill: "#666666"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5264 29.3641C15.5264 28.8145 15.9623 28.3693 16.4999 28.3693C17.0377 28.3693 17.4733 28.8148 17.4733 29.3641V35.5849C17.4733 36.1345 17.0374 36.5797 16.4999 36.5797C15.9621 36.5797 15.5264 36.1342 15.5264 35.5849V29.3641Z",
    fill: "#666666"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.128 32.679L16.5001 38.0424L12.8719 32.679H20.128Z",
    fill: "#666666"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4736 9.88533C17.4736 10.4349 17.0377 10.8801 16.5001 10.8801C15.9623 10.8801 15.5267 10.4346 15.5267 9.88533V3.66454C15.5267 3.11497 15.9626 2.66976 16.5001 2.66976C17.038 2.66976 17.4736 3.11526 17.4736 3.66454V9.88533Z",
    fill: "#666666"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.128 6.57077L16.5001 1.20708L12.8719 6.57077H20.128Z",
    fill: "#666666"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPHWithArrows);
export default __webpack_public_path__ + "static/media/pHWithArrows.d4b7af8f.svg";
export { ForwardRef as ReactComponent };